export default __webpack_public_path__ + "media/icons/blog-icon-active-d7c5e73f.svg";